import { useState } from 'react'
import { useAlert } from 'react-alert'

import { resetFactors } from '../../../../main/usecases'

import { useOnChangeDetect, useModalBox } from '../../../contexts'
import { Button } from '../../../components'

const DeleteFactorModal = ({ cdTypeToService, cdFactor }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteCustomer = async (
    cdTypeToService: number,
    cdFactor: number
  ) => {
    try {
      setLoading(true)
      await resetFactors({
        cdTypeToService: cdTypeToService,
        cdFactor: cdFactor
      }).load()
      modalClose(true)
      alert.show('Fator personalizado deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar o Fator personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>Deseja realmente deletar o fator personalizado?</p>
      <div>
        <Button
          disabled={loading}
          hasredButton
          onClick={() => handleDeleteCustomer(cdTypeToService, cdFactor)}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteFactorModal
